import { CandidateFilterTypeKey } from 'modules/candidate-profile/types/CandidateSearchFilter';

export const LEGACY_FILTER_KEYS: Record<string, string> = {
  talentListIds: 'candidateProfileLists',
  currentRoleStartDate: 'timeInRole'
};

// `currentRoleStartDate` is also a live date field in its own right, so only a
// count of years under that name is the legacy time-in-role key.
const LEGACY_TYPE_KEYS: Record<string, CandidateFilterTypeKey[]> = {
  currentRoleStartDate: [CandidateFilterTypeKey.NUMBER]
};

export const canonicalFilterField = (
  field: string,
  typeKey?: CandidateFilterTypeKey
): string => {
  const alias = LEGACY_FILTER_KEYS[field];
  if (!alias) return field;

  const legacyTypeKeys = LEGACY_TYPE_KEYS[field];
  if (!legacyTypeKeys) return alias;

  return typeKey && legacyTypeKeys.includes(typeKey) ? alias : field;
};
